import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Modal from 'react-modal';
import { useToasts } from 'react-toast-notifications';

import * as LotService from '../../services/Lot';
import * as Utils from '../../utils/global';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

type Inputs = {
  name: {
    first: string,
    last: string,
  }
  phone: string,
};

Modal.setAppElement('#root');

const PublishModal = ({
  modalIsOpen,
  closeModal,
  goFinishStep,
}: {
  modalIsOpen: any,
  closeModal: any,
  goFinishStep?: boolean,
}) => {
  const { register, reset, handleSubmit, formState: { isDirty, isValid } } = useForm<Inputs>({
    mode: "onChange",
  });

  const { addToast } = useToasts();

  const onSubmit = async (data: Inputs) => {
    // facebook information
    const fbp = Utils.getFbp();
    const fbc = Utils.getFbc();

    try {
      await LotService.wantPublish({
        ...data,
        fbp,
        fbc,
      });
      setFinishStep(true);
    } catch(err) {
      addToast(err.response.data.message, { appearance: 'error' });
    }
  };

  useEffect(() => {
    const call = async () => {
      const fbp = Utils.getFbp();
      const fbc = Utils.getFbc();
      await LotService.wantPublish({
        fbp,
        fbc,
      });
    };
    call();
  }, [goFinishStep])

  const [finishStep, setFinishStep] = useState<boolean>(goFinishStep ? true : false);

  return (
    <Modal
      isOpen={modalIsOpen}
      style={customStyles}
      contentLabel="Login Modal"
    >
      <div className="container">
        <div className="top-actions close">
          <button
            onClick={closeModal}
          >
            <img src="https://campomercadobucket.s3.sa-east-1.amazonaws.com/assets/icons/ic_cancel.svg" alt="close" />
          </button>
        </div>
        <div className="row-top-information" style={{
          marginBottom: "15px"
        }}>
          {finishStep && <img src="https://campomercadobucket.s3.sa-east-1.amazonaws.com/assets/icons/ic_checkmark.svg" className="status" style={{
            width: '100px',
            margin: '20px',
          }} />}
          <h2 style={{
            marginTop: "0"
          }}>{!finishStep ? 'Publicá tu Lote' : 'Todo Listo!'}</h2>
        </div>
        {!finishStep && 
          (<div className="row-form"  style={{
            marginTop: "15px"
          }}>
            <p>Dejanos tus datos y nos comunicaremos contigo para continuar el proceso y aprovechar las ventajas de Campo Mercado.<br/> Publicá sin sorpresas ni costos asociados.</p>
            <form className="form-container" onSubmit={handleSubmit(onSubmit)}>
              <div className="form-horizontal">
                <div className="input-group">
                  <input
                    className="form-control"
                    {...register("name.first", { required: true })}
                    placeholder="Nombre"
                  />
                </div>

                <div className="input-group">
                  <input
                    className="form-control"
                    {...register("name.last", { required: true })}
                    placeholder="Apellido"
                  />
                </div>

                <div className="input-group">
                  <input
                    className="form-control"
                    {...register("phone", { required: true })}
                    placeholder="Teléfono"
                  />
                </div>

                <div className="form-group submit" style={{
                  padding: '0 10px'
                }}>
                  <div className="row">
                    <button
                      className="btn-continue"
                      disabled={!isDirty || !isValid}
                      type="submit"
                      style={{
                        width: '100%',
                      }}
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
          </form>
        </div>
      )}
      {finishStep && (
        <>
          <div>
            <p>Recibimos tus datos correctamente y nos contactaremos a la brevedad para que tu ganado quede publicado</p>
          </div>
          <div className="form-group submit" style={{
            padding: '0 10px'
          }}>
            <div className="row">
              <button
                className="btn-continue"
                onClick={closeModal}
                style={{
                  width: '100%',
                }}
              >
                Entendido
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  </Modal>);
};

export default PublishModal;
